import { getChangelogs, getSelectOptions, type SelectOptionsParams } from '@dc-trans/data-layer';
import { useQuery } from '@tanstack/react-query';

export const selectOptionsKeys = {
  all: ['selectOptions'] as const,
  endpoint: (endpoint: string, params?: SelectOptionsParams) => [...selectOptionsKeys.all, endpoint, params] as const,
};

export const useSelectOptions = <T = any>(
  endpoint: string,
  params?: SelectOptionsParams,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    gcTime?: number;
  }
) => {
  return useQuery({
    queryKey: selectOptionsKeys.endpoint(endpoint, params),
    queryFn: () => getSelectOptions<T>(endpoint, params),
    enabled: options?.enabled ?? !!endpoint,
    staleTime: options?.staleTime ?? 5 * 60 * 1000, // 5 minutes
    gcTime: options?.gcTime ?? 10 * 60 * 1000, // 10 minutes
  });
};

export const useChangeLogs = (
  url: string,
  params?: SelectOptionsParams,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    gcTime?: number;
    queryKey?: string[];
  }
) => {
  return useQuery({
    ...options,
    queryFn: () => getChangelogs(url, params),
    queryKey: [...(options?.queryKey || ['changelogs']), params],
  });
};
